import React from 'react';
import { TextField, InputAdornment, withStyles, makeStyles } from '@material-ui/core';
import { primaryColor } from '../utils/colors';

const CssTextField = withStyles({
    root: {
        '& label.Mui-focused': {
            color: primaryColor,
        },
        '& .MuiInput-underline:after': {
            borderColor: primaryColor,
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: primaryColor,
            },
            '&:hover fieldset': {
                borderColor: primaryColor,
            },
            '&.Mui-focused fieldset': {
                borderColor: primaryColor,
            },
        },
    },
})(TextField);

const useStyles = makeStyles((theme) => ({
    root: {
        margin: '30px auto 10px auto',
    },
    body: {
        margin: props => props.margin,
        backgroundColor: props => props.backgroundColor,
    },
}));

const CustomTextField = props => {

    const styledClasses = useStyles(props);

    let startAdornment = null;

    if (props.children) {
        startAdornment = (
            <InputAdornment position="start">
                {props.children}
            </InputAdornment>
        );
    }

    let endAdornment = null;

    if (props.endIcon) {
        endAdornment = (
            <InputAdornment position="end" >
                {props.endIcon}
            </InputAdornment>
        )
    }

    return (
        <div>
            <CssTextField
                className={styledClasses.body}
                inputRef={props.reference}
                id={props.id}
                type={props.type}
                label={props.label}
                variant="outlined"
                placeholder={props.placeHolder}
                defaultValue={props.defaultValue}
                required={props.required}
                multiline={props.multiline}
                minRows={props.rows ? props.rows : 1}
                onChange={props.onChangeHandler ? props.onChangeHandler : () => { }}
                fullWidth
                InputProps={{
                    startAdornment,
                    endAdornment,
                }}
            />
        </div>
    );
};

export default CustomTextField;